import { createStyles, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { getClassName } from '../../utils/styles';
import RenderDesktop from './breakpoints/RenderDesktop';
import RenderMobile from './breakpoints/RenderMobile';

const styles = createStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100%',
    margin: 'auto',
  },
  topVAlign: {
    justifyContent: 'flex-start',
  },
  centerVAlign: {
    justifyContent: 'center',
  },
  bottomVAlign: {
    justifyContent: 'flex-end',
  },
  leftHAlign: {
    alignItems: 'flex-start',
  },
  centerHAlign: {
    alignItems: 'center',
  },
  rightHAlign: {
    alignItems: 'flex-end',
  },
  smallSize: {
    maxWidth: theme.breakpoints.values.sm,
  },
  mediumSize: {
    maxWidth: theme.breakpoints.values.md,
  },
  largeSize: {
    maxWidth: theme.breakpoints.values.lg,
  },
  fullSize: {
    maxWidth: '100%',
  },
}));

const CommonContainer = React.forwardRef((props, ref) => {
  const {
    classes,
    className,
    style,
    vAlign = 'top',
    hAlign = 'center',
    size = 'full',
    children,
  } = props;
  return (
    <>
      <RenderDesktop>
        <div
          ref={ref}
          style={style}
          className={classNames(
            classes.root,
            getClassName(classes, `${vAlign}VAlign`),
            getClassName(classes, `${hAlign}HAlign`),
            getClassName(classes, `${size}Size`),
            className,
          )}
        >
          {children}
        </div>
      </RenderDesktop>
      <RenderMobile>
        <div
          ref={ref}
          style={style}
          className={classNames(
            classes.root,
            getClassName(classes, `centerHAlign`),
            className,
          )}
        >
          {children}
        </div>
      </RenderMobile>
    </>
  );
});

export default withStyles(styles, { name: 'CommonContainer' })(CommonContainer);
